import { useEffect } from 'react'
import { lastValidPageIndex } from './conductorUtils'

/** Keep local page index in range when totals shrink (mutations, refetch, filter changes). */
export function useClampedPage(
  total: number | undefined,
  resultsPerPage: number | undefined,
  page: number,
  setPage: (page: number) => void
): void {
  useEffect(() => {
    if (total == null || resultsPerPage == null || resultsPerPage <= 0) {
      return
    }
    const maxPage = lastValidPageIndex(total, resultsPerPage)
    if (page > maxPage) {
      setPage(maxPage)
    }
  }, [total, resultsPerPage, page, setPage])
}
